module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-21.3aa43d57.png";